import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ApigeeService } from '../auth/apigee/apigee.service';

export class GoogleLoginManagerCfg {
  public googleAccount: string;
  public redirectUri: string;
  public googleScope: string;
}

@Injectable({
  providedIn: 'root'
})
export class ServerAddressesCfgService {
  private data: any;
  url: string = '';
  private readonly RAAS_TOKEN: string = "apiToken";

  constructor(private httpClient: HttpClient, private router: Router, private apigeeService: ApigeeService) {
  }

  public async initialize(): Promise<void> {
    let apiTokenString = localStorage.getItem(this.RAAS_TOKEN);

    if (apiTokenString) {
      await this.getConfigFromApi();
    }

    return new Promise<any>(resolve => resolve({}));
  }

  /**
   * Obtiene las urls para los apis
   * @returns  Promsesa de la llamada a las urls
   */
  private async getConfigFromApi() {

    return new Promise<any>(resolve => {
      this.httpClient
        .get<any>(this.url + "/serveraddresses")
        .toPromise()
        .then(response => {
          var urls = {};
          response.serverAddresses.forEach((element: { key: string; value: string }) => {
            urls[element.key] = element.value;
          });

          this.data = urls;
          resolve(urls);
        })
        .catch(_ => {
          console.error("Error en la carga del Server Addresses");
          this.apigeeService.logout();
          resolve({});
        });
    });
  }

  /**
   * Obtiene los datos de las urls
   * @returns urls
   */
  public getData(): any {
    return this.data;
  }
}
